const transform = (data) => ({
  ...data,
  research_project_eval_items: data?.research_project_eval_items.map(
    (item) => ({
      ...item,
      state: data?.state,
    })
  ),
});
export default transform;
